export const getThirdAnalysesData = state => state.thirdAnalyses.all;
export const getThirdAnalysisData = state => state.thirdAnalyses.thirdAnalysis;
export const thirdAnalysesIsFetching = state => state.thirdAnalyses.loading.all;
export const thirdAnalysisIsFetching = state => state.thirdAnalyses.loading.thirdAnalysis;